import { Component } from '@angular/core';

@Component({
  selector: 'feature-notification-handling-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
  standalone: false,
})
export class NotificationComponent {}
